import React from 'react';
import { motion } from 'framer-motion';
import { RABEMAR_MODEL } from '../../data/solutions';
export function ModelSteps() {
  return <ol className="mt-12 grid gap-px bg-mist-200 md:grid-cols-5" data-id="element-225" data-mp="3ncrqu2g17ezn">
      {RABEMAR_MODEL.map((step, i) => <motion.li key={step.code} initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.26,
      delay: i * 0.05,
      ease: [0.23, 1, 0.32, 1]
    }} className="bg-white p-6 md:p-7" data-id="element-226" data-mp="3j8tu1ye6ig9r" data-mpi={i}>
          <span className="font-display text-sm font-bold tabular-nums text-accent-500" data-id="element-227" data-mp="34jxpibbbzldw">{step.code}</span>
          <h3 className="mt-4 font-display text-xl font-bold tracking-tight text-graphite-900" data-id="element-228" data-mp="2vl2iwy4dk9a2">{step.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-graphite-500" data-id="element-229" data-mp="2qlps62adui27">{step.text}</p>
        </motion.li>)}
    </ol>;
}